module.exports = __webpack_public_path__ + "img/commission.c57876fd.svg";